<template>
  <v-radio-group
    v-model="overwriteFamily"
    v-validate="overwriteFamilyRules"
    class="v-input--radio-group_inner"
    :disabled="chosenOption !== 2"
    :error-messages="errors.collect('overwriteFamilyRules')"
    :data-vv-as="$t('label.family_data')"
    data-vv-name="overwriteFamilyRules"
    @change="emitData()"
  >
    <v-layout
      class="align-stretch"
      wrap
    >
      <v-flex xs12>
        <h3 class="display-2 mb-2">
          {{ $t('alikes_families.overwrite_title') }}
        </h3>
      </v-flex>
      <v-flex
        v-for="(family, index) in notAttributedFamilies"
        :key="index"
        md6
      >
        <EntranceFamilyItem
          :value="family.family_edition_id"
          :family="family"
        >
          <template #indicator>
            <SimilarIndicator
              v-if="getSimilarity(family?.family_edition_id)"
              :value="getSimilarity(family.family_edition_id)"
            />
          </template>
        </EntranceFamilyItem>
      </v-flex>
      <div
        v-if="othersFamilies.length > 0"
        class="f-14 fw-600"
      >
        {{ $t('message.edit_family_data') }}
      </div>
    </v-layout>
  </v-radio-group>
</template>

<script>
import EntranceFamilyItem from '@/components/widgets/addFamily/familySimilar/EntranceFamilyItem';
import SimilarIndicator from '@/components/widgets/addFamily/familySimilar/SimilarIndicator';
import overwriteSimilarFamilies from '@/mixins/overwriteSimilarFamilies';

export default {
    name: 'SimilarActionsOverwriteFamily',
    components: { EntranceFamilyItem, SimilarIndicator },
    mixins: [overwriteSimilarFamilies],
    inject: ['$validator'],
    props: {
        chosenOption: {
            required: true,
            validator: (v) => typeof v === 'number' || v === null
        },
        chosenFamily: {
            required: true,
            validator: (v) => typeof v === 'number' || v === null
        }
    },
    data: () => ({
        overwriteFamily: null
    }),
    computed: {
        overwriteFamilyRules () {
            return this.chosenFamily === -1 ? 'required' : '';
        }
    },
    watch: {
        formattedSimilarFamilies: {
            handler (val) {
                this.overwriteFamily = null;
            }
        }
    },
    methods: {
        emitData () {
            this.$emit('changeOverwriteFamily', this.overwriteFamily);
        },
        getSimilarity (id) {
            if (!id) return null;
            return this.similarFamilies.find((el) => el.family_edition.family_edition_id === id)
                ?.similarity;
        }
    }
};
</script>

<style scoped></style>
